import React, { useState, useRef } from "react";
import {
  Form,
  Input,
  Button,
  PageHeader,
  Row,
  Col,
  Divider,
  DatePicker,
} from "antd";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import DemandTemplate from "../../../components/contracts/DemandTemplate";
import AddDemandConditions from "../../../components/contracts/AddDemandConditions";
import DemandLetterItemsForm from "../../../components/contracts/DemandLetterItemsForm";
import { dateFormat } from "../../../utils/Constants";

export default function AddDemandLetter() {
  const { demandform } = Form.useForm();
  const printRef = useRef();
  const [englishTitle, setEnglishTitle] = useState("English Title");
  const [agencyName, setAgencyName] = useState("");
  const [agencyNameArabic, setAgencyNameArabic] = useState("");
  const [arabicTitle, setArabicTitle] = useState("Arabic Title");
  const [issueDate, setIssueDate] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [conditionItems, setConditionItems] = useState([]);
  const [addressEnglish, setAddressEnglish] = useState("");
  const [addressArabic, setAddressArabic] = useState("");
  const [licenseNo, setLicenseNo] = useState("");
  const [workingDaysPerWeek, setWorkingDaysPerWeek] = useState(6);
  const [workingDaysPerMonth, setWorkingDaysPerMonth] = useState(26);
  const [workingHoursPerDay, setWorkingHoursPerDay] = useState(10);
  const [services, setServices] = useState();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const onFinish = () => {};
  const onFinishFailed = () => {};
  console.log(
    "Condition items list",
    conditionItems.map((x) => x)
  );
  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Add Demand Letters"
        subTitle="Enter details to add demand letter"
        extra={
          <Button type="primary" onClick={() => setShowModel(true)}>
            Add Conditions
          </Button>
        }
      />
      <AddDemandConditions
        showModel={showModel}
        setShowModel={setShowModel}
        setConditionItems={setConditionItems}
        conditionItems={conditionItems}
      />
      <Form
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row style={{ margin: "15px 0px" }}>
          <Col span={12}>
            <Form.Item
              label="Subject Title in English"
              name="englishTitle"
              rules={[
                { required: true, message: "Please enter Title in english" },
              ]}
            >
              <Input
                placeholder="Enter English title"
                onChange={(e) => setEnglishTitle(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Agency Name in English"
              name="agencyNameInEnglish"
              rules={[
                {
                  required: true,
                  message: "Please enter Agency Name in english",
                },
              ]}
            >
              <Input
                placeholder="Enter English title"
                onChange={(e) => setAgencyName(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="License No."
              name="licenseNo"
              rules={[
                { required: true, message: "Please enter License Number" },
              ]}
            >
              <Input
                placeholder="License Number"
                onChange={(e) => setLicenseNo(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Address in English"
              name="addressenglish"
              rules={[{ required: true, message: "Please enter Address" }]}
            >
              <Input
                placeholder="Visa Number"
                onChange={(e) => setAddressEnglish(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Working days/week"
              name="workingdaysperweek"
              rules={[
                {
                  required: true,
                  message: "Please enter working days per week",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Working days per week"
                onChange={(e) => setWorkingDaysPerWeek(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Working Hours/day"
              name="workinghoursperweek"
              rules={[
                {
                  required: true,
                  message: "Please enter working hours per day",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Working days per week"
                onChange={(e) => setWorkingHoursPerDay(e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Subject Title in Arabic"
              name="arabicTitle"
              rules={[
                { required: true, message: "Please enter Title in arabic" },
              ]}
            >
              <Input
                placeholder="Enter Arabic title"
                onChange={(e) => setArabicTitle(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Agency Name in Arabic"
              name="agencyNameInArabic"
              rules={[
                {
                  required: true,
                  message: "Please enter Agency Name in Arabic",
                },
              ]}
            >
              <Input
                placeholder="Enter Agency name in Arabic"
                onChange={(e) => setAgencyNameArabic(e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Issue Date" name="issueDate">
              <DatePicker
              placeholder="DD/MM/YYYY"
              format={dateFormat}
                onChange={(date, dateString) => {
                  setIssueDate(dateString);
                }}
              />
              {/* <Input type="date"  onChange={(e)=> setIssueDate(e.target.value)}/> */}
            </Form.Item>
            <Form.Item
              label="Address in Arabic"
              name="addressArabic"
              rules={[
                { required: true, message: "Please enter Address in arabic" },
              ]}
            >
              <Input
                placeholder="Address in arabic"
                onChange={(e) => setAddressArabic(e.target.value)}
              />
            </Form.Item>
            <Form.Item
              label="Working Days/Month"
              name="workingdayspermonth"
              rules={[
                {
                  required: true,
                  message: "Please enter working days per month",
                },
              ]}
            >
              <Input
                placeholder="Working Days per month"
                onChange={(e) => setWorkingDaysPerMonth(e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Services" name="services">
              <Input.TextArea
                rows={2}
                placeholder="Enter Services"
                onChange={(e) => setServices(e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Divider orientation="left">Add Items</Divider>
            <Row>
              <DemandLetterItemsForm />
            </Row>
            <Button
              type="primary"
              icon={<PrinterOutlined />}
              onClick={handlePrint}
            >
              Print Document
            </Button>
          </Col>

          <Col span={20} offset={2}>
            <DemandTemplate
              ref={printRef}
              agencyName={agencyName}
              agencyNameArabic={agencyNameArabic}
              englishTitle={englishTitle}
              addressEnglish={addressEnglish}
              addressArabic={addressArabic}
              workingDaysPerWeek={workingDaysPerWeek}
              workingDaysPerMonth={workingDaysPerMonth}
              workingHoursPerDay={workingHoursPerDay}
              services={services}
              arabicTitle={arabicTitle}
              issueDate={issueDate}
              licenseNo={licenseNo}
              conditionItems={conditionItems}
            />
          </Col>
        </Row>
      </Form>
    </>
  );
}
